@if (Error) {
  <mj-empty-state Variant="error" Title="Couldn't load Home" [Message]="Error"><div actions><button type="button" mjButton variant="primary" (click)="Refresh()">Try again</button></div></mj-empty-state>
} @else if (NoSeason) {
  <mj-empty-state Variant="empty" Title="OEP is between seasons" Message="There is no active OEP season yet. We will email you when your role opens." />
} @else if (VM) {
<section class="oep-home">
  <!-- markup.html:202-215 -->
  <div class="oep-home__intro">
    <div>
      <h1 class="oep-h1">{{ VM.Greeting }}</h1>
      <p class="oep-lead">Welcome to the Outstanding Emerging Presenters (OEP) platform. You will use this platform to fulfill your OEP role. You can view the OEP feedback and awards timeline below@if (VM.ResourcesTabNote) {, and resources related to your role under the Resources tab above}.</p>
      <p class="oep-lead">If you have any questions, reach out to us at <a href="mailto:membership@agu.org">membership@agu.org</a>.</p>
    </div>
    <div class="oep-home__deadline"><span class="oep-eyebrow">{{ VM.Deadline.Label }}</span><strong>{{ VM.Deadline.Value }}</strong></div>
  </div>
  <!-- markup.html:217-231 -->
  <div class="oep-card oep-home__season">
    <div class="oep-row"><span class="oep-eyebrow">Your OEP season</span><span class="oep-home__stage">{{ VM.Season.Stage }} · {{ VM.Season.Months }}</span></div>
    <ol class="oep-home__months">
      @for (m of VM.Season.Items; track m.Label) {
        <li class="oep-home__month" [class.oep-home__month--on]="m.On" [class.oep-home__month--next]="m.Next"><span class="oep-home__month-label">{{ m.Label }}</span><span class="oep-home__month-note">{{ m.Note }}</span></li>
      }
    </ol>
  </div>
  <!-- markup.html:233-258 -->
  <h2 class="oep-h2 oep-home__h2">Needs you now</h2>
  <p class="oep-meta">Current and upcoming tasks for your review.</p>
  <ul class="oep-stack oep-home__list">
    @for (t of VM.Tasks; track t.Title) {
      <li class="oep-card oep-home__task">
        <div class="oep-home__task-body">
          <oep-role-chip [Role]="t.Role" />
          <div class="oep-home__task-title">{{ t.Title }}</div>
          <div class="oep-meta">{{ t.Meta }}</div>
          <div class="oep-due" [class.oep-due--urgent]="t.Urgent">{{ t.Due }}</div>
        </div>
        <button type="button" mjButton variant="primary" class="oep-home__cta" (click)="Open(t)">{{ t.Cta }}</button>
      </li>
    }
  </ul>
  @if (VM.NoTasks) {
    <div class="oep-card oep-home__empty"><strong>Nothing needs you right now</strong><p class="oep-meta">We'll email you when your next role opens. {{ VM.NextUpNote }}</p></div>
  }
  <!-- markup.html:260-297 -->
  <div class="oep-home__lower">
    <div>
      <h2 class="oep-h2 oep-home__h2">Guidance for what you're doing now</h2>
      <ul class="oep-stack oep-home__list">
        @for (r of VM.Guidance; track r.Title) {
          <li><a class="oep-card oep-home__resource" [href]="r.Url" target="_blank" rel="noopener"><span class="oep-home__kind">{{ r.Kind }}</span><span><strong>{{ r.Title }}</strong><span class="oep-meta oep-home__block">{{ r.Note }}</span></span><span class="oep-sr"> (opens in a new tab)</span></a></li>
        }
      </ul>
    </div>
    <div>
      @if (VM.Done.length) {
        <h2 class="oep-h2 oep-home__h2">Already done</h2>
        <ul class="oep-card oep-home__done">
          @for (d of VM.Done; track d.Title) {
            <li><span class="oep-home__tick" aria-hidden="true">✓</span><span><span class="oep-home__block">{{ d.Title }}</span>@if (d.When) { <span class="oep-home__when oep-home__block">{{ d.When }}</span> }</span></li>
          }
        </ul>
      }
      @if (VM.Dormant.length) {
        <div class="oep-home__dormant">
          <p class="oep-meta">You also hold these roles this season. They open on their own schedule.</p>
          <ul class="oep-home__dormant-chips">
            @for (r of VM.Dormant; track r.Role) { <li class="oep-home__dormant-chip">{{ r.Label }} · {{ r.Opens }}</li> }
          </ul>
        </div>
      }
    </div>
  </div>
</section>
}
